import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const documentCategoryImporterSelectors = importerSelectors('documentCategory.importer');

export default documentCategoryImporterSelectors;
